import { actionCreator } from '@ardoq/rxbeach';

export const bypassLimitAction = actionCreator(
  '[dependencyMatrix] BYPASS_LIMIT'
);
